import React, { FC } from 'react'

import Typography from '@mui/material/Typography'

import { Alert } from '@app/types/alert'
import { preciseRound } from '@app/helpers'
import { AppIcon } from '@app/components/AppIcon'
import { useBgAlert } from '@app/hooks/useBgAlert'

import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarBGAlertProps {
	readonly alert: Alert
}

const SidebarBGAlert: FC<SidebarBGAlertProps> = ({
	alert,
}: SidebarBGAlertProps) => {
	const {
		iconType,
		eventTypeBgData,
		eventTime,
		glucoseValue,
		measureUnitLabel,
	} = useBgAlert(alert)
	return (
		<>
			<AppAlertBase
				iconSlot={<AppIcon type={iconType} width={25} height={34} />}
				iconBoxSx={{ bgcolor: eventTypeBgData?.light, height: 'auto' }}
				title={alert.data?.alert_description}
				subTitle={
					<Typography
						fontFamily={'Gilroy-SemiBold, sans-serif'}
						mb={0.25}
					>
						{preciseRound(glucoseValue, 0)}

						<Typography
							component={'small'}
							variant={'caption'}
							ml={1}
						>
							{measureUnitLabel}
						</Typography>
					</Typography>
				}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarBGAlert
